$(document).on( 'preInit.dt.dtr', function (e) {
    let wrapper = e.target.parentElement.parentElement.parentElement

    if (!wrapper.classList.contains('dataTables_wrapper')) return

    let label = wrapper.querySelector('.dataTables_filter label')

    if (!label) return

    let btn = document.createElement('button')
    btn.className = 'btn'

    let icon = document.createElement('i')
    icon.className = 'fa fa-search'

    btn.append(icon)
    label.append(btn)
})
